import { baseURL } from '@/utils/confing'

export default {
    methods:{
        imgurl(str){
            if(str.substr(0,4)=='http')
            {
                return `${str}`
            }else {
                return `${baseURL}/${str}`
            }

        },
        datefilter(str){
            if(str){
                str = str.split(' ')
                return str[0]
            }
            return ''
        }
    }
}
